import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import VoiceCall from '../components/VoiceCall';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function VoiceChatPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [sessionId, setSessionId] = useState(location.state?.sessionId || null);
  const [model, setModel] = useState(location.state?.model || 'KHUSUS');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initialModel = location.state?.model || 'KHUSUS';
    setModel(initialModel);
  }, [location.state?.model]);

  useEffect(() => {
    let mounted = true;

    const ensureSession = async () => {
      if (sessionId) {
        setLoading(false);
        return;
      }

      try {
        const res = await axios.post(
          `${API_BASE_URL}/chat/session`,
          { session_name: 'Voice Chat' },
          { withCredentials: true }
        );

        if (mounted) {
          setSessionId(res.data?.id || null);
        }
      } catch {
        if (mounted) {
          setSessionId(null);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    ensureSession();
    return () => {
      mounted = false;
    };
  }, [sessionId]);

  if (loading) {
    return (
      <div className="tw flex min-h-screen items-center justify-center bg-[#111] text-white">
        Menyiapkan sesi voice chat...
      </div>
    );
  }

  if (!sessionId) {
    return (
      <div className="tw flex min-h-screen flex-col items-center justify-center gap-3 bg-[#111] px-4 text-center text-white">
        <div>Gagal membuat sesi voice chat.</div>
        <button
          type="button"
          className="rounded-full border border-white/40 px-5 py-2 text-sm"
          onClick={() => navigate('/chat')}
        >
          Kembali ke Chat
        </button>
      </div>
    );
  }

  return (
    <div className="tw min-h-screen bg-[#111] p-4">
      <VoiceCall
        sessionId={sessionId}
        model={model}
        onBack={() => navigate('/chat')}
      />
    </div>
  );
}

export default VoiceChatPage;
